































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import CloseCircleOutlineIcon from 'vue-material-design-icons/CloseCircleOutline.vue';
import ArrowUpDownBoldOutlineIcon from 'vue-material-design-icons/ArrowUpDownBoldOutline.vue';
import ContentEditor from '@/dex-shared/components/new_content/ContentEditor.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import AssertionModel from '@/dex-shared/models/AssertionModel';
import QuestionModel from '../../../dex-shared/models/QuestionModel';

export default Vue.extend({
  components: {
    ContentEditor,
    pxCard,
    pxButton,
    CloseCircleOutlineIcon,
    ArrowUpDownBoldOutlineIcon,
    draggable,
  },

  props: {
    questionId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    mutableAssertions: {
      get() {
        return this.assertions;
      },
      set(sortedAssertions: Array<AssertionModel>) {
        this.updatePositions(sortedAssertions);
      },
    },
    ...mapGetters({
      questionById: 'questionById',
    }),
    question(): QuestionModel {
      return this.questionById(this.questionId);
    },
    assertions(): Array<AssertionModel> {
      return this.question.assertions();
    },
    maxPosition(): number {
      const lastPosition = this.assertions.slice(-1)[0];
      if (lastPosition) {
        return lastPosition.position;
      }
      return -1;
    },
    correctAssertion: {
      get() {
        const correctAssertion = this.assertions.find(
          assertion => assertion.correct,
        );
        if (correctAssertion) return correctAssertion.id;
        return null;
      },
      set(assertionId: number) {
        this.updateCorrectAssertion(assertionId);
      },
    },
  },

  methods: {
    createAssertion() {
      this.$store.dispatch('CREATE_ASSERTION', {
        questionId: this.question.id,
        position: this.maxPosition + 1,
      });
    },
    async deleteAssertion(assertionId: number) {
      await this.$store.dispatch('DELETE_ASSERTION', assertionId);
      this.updatePositions(this.assertions);
    },
    updateCorrectAssertion(assertionId: number) {
      this.assertions.forEach(assertion => {
        this.$store.commit('UPDATE_ENTITY_PROP', {
          id: assertion.id,
          entity: 'assertions',
          propToUpdate: 'correct',
          value: assertion.id === assertionId,
        });
      });
    },
    updatePositions(assertions: Array<AssertionModel>) {
      assertions.forEach((assertion: AssertionModel, position: number) => {
        this.$store.commit('UPDATE_ENTITY_PROP', {
          id: assertion.id,
          entity: 'assertions',
          propToUpdate: 'position',
          value: position,
        });
      });
    },
  },
});
